// Enchanting table screen (PLR-6, M12.1). Operates on the held tool: shows the
// three seeded offers, their level + lapis cost, and a hint of one granted
// enchant; clicking an affordable slot enchants the held item. Client-only.
import { h, clear } from '../h';
import { isEmpty } from '../../../sim/game/inventory';
import type { Game } from '../../boot';

export function openEnchanting(game: Game, x: number, y: number, z: number): void {
  game.uiOpen = true;
  document.exitPointerLock();

  const overlay = h('div', { class: 'bb-window-overlay' });
  const panel = h('div', { class: 'bb-window', style: { minWidth: '320px' } });
  overlay.append(panel);
  document.body.append(overlay);

  const render = (): void => {
    clear(panel);
    panel.append(h('div', { class: 'bb-window-title' }, 'Enchant'));
    const held = game.playerState.inventory.held();
    const heldName = isEmpty(held) ? '' : game.registries.items.nameOf[held.item] ?? '';
    panel.append(h('div', { style: { margin: '4px 0 10px', opacity: '0.85' } }, heldName ? `Holding: ${heldName}` : 'Hold an un-enchanted tool'));

    const offers = game.enchantOffers(x, y, z);
    if (offers.length === 0) {
      panel.append(h('div', { style: { opacity: '0.7', padding: '8px 0' } }, 'No enchantments available.'));
    }
    offers.forEach((offer, i) => {
      const afford = game.playerState.caps.infiniteResources || game.playerState.xpLevel >= offer.level;
      const hint = offer.enchants.map((e) => `${e.id.replace(/_/g, ' ')} ${e.lvl}`).join(', ') || '—';
      const row = h('button', {
        class: 'bb-btn',
        type: 'button',
        'data-slot': `ench-${i}`,
        style: {
          display: 'flex', width: '100%', gap: '10px', alignItems: 'center', margin: '4px 0',
          textAlign: 'left', opacity: afford ? '1' : '0.5',
        },
      },
        h('span', { style: { fontWeight: '700', minWidth: '18px' } }, String(i + 1)),
        h('span', { style: { flex: '1' } }, hint),
        h('span', { style: { opacity: '0.85', whiteSpace: 'nowrap' } }, `Lv ${offer.level} · ${offer.lapisCost}◆`));
      row.addEventListener('mousedown', (e) => { e.preventDefault(); if (game.applyEnchant(x, y, z, i)) render(); });
      panel.append(row);
    });

    const close = h('button', { class: 'bb-btn', type: 'button', style: { marginTop: '10px' } }, 'Close');
    close.addEventListener('mousedown', (e) => { e.preventDefault(); doClose(); });
    panel.append(close);
  };

  let closed = false;
  const doClose = (): void => {
    if (closed) return;
    closed = true;
    document.removeEventListener('keydown', onKey, true);
    overlay.remove();
    game.uiOpen = false;
    void game.renderer.domElement.requestPointerLock();
  };
  const onKey = (e: KeyboardEvent): void => {
    if (e.code === 'Escape' || e.code === 'KeyE') { e.preventDefault(); e.stopPropagation(); doClose(); }
  };
  document.addEventListener('keydown', onKey, true);
  overlay.addEventListener('mousedown', (e) => { if (e.target === overlay) doClose(); });
  render();
}
